import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { Grid, TextField } from '@material-ui/core';
import { useConfirmMfaEnrolmentMutation } from 'generated/graphql';
import React, { useState } from 'react';
import QRCode from 'qrcode.react';
import { MFA_COPY, mfaWrapStyle } from './MFACopy';

interface MFAEnrolmentProps {
	mode: 'RESET' | 'ENABLE';
	otpURL?: string;
	onClose: () => void;
	onConfirmed: () => void;
}

export const MFAEnrolment = ({
	mode,
	otpURL,
	onClose,
	onConfirmed,
}: MFAEnrolmentProps) => {
	const [otpCode, setOtpCode] = useState('');
	const [openAlert, setOpenAlert] = useState(false);
	const [message, setMessage] = useState('');
	const user = JSON.parse(localStorage.getItem('loggedInUser') || 'null');

	const [confirmMfaEnrolment, { loading: confirmLoading }] =
		useConfirmMfaEnrolmentMutation({
			onError: error => {
				const gqlMessage = error?.graphQLErrors?.[0]?.message;
				setMessage(gqlMessage || error?.message || 'Invalid OTP code, please try again');
				setOpenAlert(true);
			},
			onCompleted: () => {
				setOtpCode('');
				onConfirmed();
			},
		});

	const onVerify = () => {
		if (!otpCode) return;
		confirmMfaEnrolment({ variables: { otpCode } });
	};

	return (
		<>
			{confirmLoading && <Loading />}
			<MainHeader
				mainBtn="close"
				onClick={onClose}
				smTitle="Outlet App"
				title={user?.companyName || 'Profile'}
				routeSegments={[
					{ name: 'Profile' },
					{
						name:
							mode === 'RESET'
								? MFA_COPY.resetBreadcrumb
								: MFA_COPY.sectionTitle,
						current: true,
					},
				]}
			/>

			<ContentWrapper footer>
				<CardContents
					section={{
						header: {
							title:
								mode === 'RESET'
									? MFA_COPY.resetBreadcrumb
									: MFA_COPY.sectionTitle,
						},
					}}
				>
					<div className="content-wrap full">
						<div style={mfaWrapStyle}>{MFA_COPY.scanBody}</div>
					</div>
					{mode === 'RESET' && (
						<div className="content-wrap full">
							<div style={mfaWrapStyle}>{MFA_COPY.resetRemovesPrevious}</div>
						</div>
					)}

					{otpURL && (
						<div className="content-wrap full">
							<Grid container justify="center">
								<div style={{ background: '#ffffff', padding: '12px' }}>
									<QRCode value={otpURL} size={160} />
								</div>
							</Grid>
						</div>
					)}

					<TextField
						fullWidth
						autoComplete="off"
						name="otpCode"
						label={MFA_COPY.otpLabel}
						value={otpCode}
						onChange={e => setOtpCode(e.target.value)}
						inputProps={{ inputMode: 'numeric', maxLength: 6 }}
					/>
				</CardContents>
			</ContentWrapper>

			<CommonDialog
				fullWidth={true}
				open={openAlert}
				onClose={() => setOpenAlert(false)}
				sections={{
					header: { title: MFA_COPY.sectionTitle },
					body: () => <div>{message}</div>,
					footer: {
						actions: [
							{
								displayText: 'Ok',
								props: {
									onClick: () => setOpenAlert(false),
									variant: 'contained',
									color: 'primary',
								},
							},
						],
					},
				}}
			/>

			<Footer
				options={[
					{
						name: MFA_COPY.verifyButton,
						onClick: () => onVerify(),
						color: 'primary',
						disabled: !otpCode || confirmLoading,
					},
				]}
			/>
		</>
	);
};
